// extracted by mini-css-extract-plugin
export default {"summary":"summary_summary__19gJc","price":"summary_price__PAxRT text_type_digits-medium","currency":"summary_currency__xkohJ","digits":"summary_digits__98+Ni"};